import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const AuthTokenActions = createActionGroup({
  source: 'AuthToken',
  events: {
    'Start Session': emptyProps(),
    'Start Session Success': props<{
      token: string;
      expiryDate: Date;
      sessionIdentifier: string;
    }>(),
    'Handle Session Failure': props<{ error: HttpErrorResponse }>(),
  },
});
